<div class="dashboard-bar" fxFill fxLayout="column" fxLayoutGap="10px">
  <div fxLayout="row">
    <form
      [formGroup]="barForm"
      dashboardConnectForm
      [connectForm]="selectedBar ? selectedBar : null"
      fxFill
      fxLayout="column"
      fxLayoutGap="10px"
    >
      <div class="dashboard-bar__form" fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px">
        <div>
          <mat-tab-group
            mat-align-tabs="end"
            (selectedTabChange)="selectTemplateLanguage($event)"
            #languageTabs
            [disablePagination]="true"
            [selectedIndex]="selectedLanguage?.tabIndex"
          >
            <mat-tab *ngFor="let language of supportedLanguages" [label]="language?.name">
              <ng-container *ngTemplateOutlet="tabContent"></ng-container>
            </mat-tab>
          </mat-tab-group>
          <ng-template #tabContent>
            <div formArrayName="barTranslations" *ngFor="let item of barTranslations.controls; let i = index">
              <mat-form-field
                [formGroupName]="i"
                *ngIf="
                  item.get('language').value === selectedLanguage?.code && item.get('identifier').value === BAR_TITLE
                "
                fxFlex="100"
              >
                <input matInput formControlName="translation" [placeholder]="'Bar Title'" />
                <mat-error *ngIf="item.get('translation').hasError('required')">
                  Bar Title is <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="item.get('translation').hasError('maxlength')">
                  Bar Title should have
                  <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong> characters
                </mat-error>
              </mat-form-field>
            </div>
          </ng-template>
        </div>
        <div>
          <mat-tab-group
            mat-align-tabs="end"
            animationDuration="0ms"
            #languageTabsEditor
            (selectedTabChange)="selectTemplateLanguage($event)"
            [disablePagination]="true"
            [selectedIndex]="selectedLanguage?.tabIndex"
          >
            <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
              <ng-template matTabContent>
                <div formArrayName="barTranslations" *ngFor="let item of barTranslations?.controls; let i = index">
                  <div
                    class="dashboard-bar__form-text-editor"
                    [formGroupName]="i"
                    *ngIf="
                      item.get('language').value === selectedLanguage?.code && item.get('identifier').value === BAR_TEXT
                    "
                    fxFill
                  >
                    <label class="dashboard-bar__form-text-editor-label">Bar Text</label>
                    <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
                    <mat-error
                      class="dashboard-bar__form-text-editor-error"
                      *ngIf="item.invalid && item.get('translation').hasError('maxlength')"
                    >
                      Bar Text should have
                      <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong>
                      characters
                    </mat-error>
                  </div>
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
        <div *ngIf="this.selectedBar">
          <mat-checkbox formControlName="hasDetails"> Details Page </mat-checkbox>
          <dashboard-details-page
            formControlName="detailsPage"
            *ngIf="barForm?.value?.hasDetails"
            [hasDetails]="barForm?.value?.hasDetails"
          ></dashboard-details-page>
        </div>
      </div>
    </form>
  </div>
  <div fxLayout="row" fxLayoutAlign="end">
    <div fxLayout="row" fxLayoutAlign="end center" *ngIf="isEditingBar">
      <button mat-raised-button color="accent" (click)="saveBar()">
        {{ 'Save Bar' | uppercase }}
      </button>
      <button mat-button (click)="cancelEditingBar()">
        {{ 'Cancel' | uppercase }}
      </button>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between end" *ngIf="!isEditingBar">
      <button mat-raised-button color="accent" (click)="saveBar()">
        {{ 'Add Bar' | uppercase }}
      </button>
    </div>
  </div>
  <div class="dashboard-bar__bars-list" fxFill fxLayout="column" fxLayoutGap="10px">
    <label *ngIf="bars?.length" class="dashboard-bar__bars-list-label">
      {{ 'Bars:' }}
    </label>
    <div fxLayout="column" fxLayoutAlign="space-between stretch" *ngIf="bars?.length">
      <mat-radio-group fxLayout="row" fxLayoutAlign="space-between start" [(ngModel)]="radioGroup">
        <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="10px">
          <mat-radio-button
            *ngFor="let bar of bars; let i = index"
            [value]="bar"
            fxLayout="row"
            fxLayoutAlign="space-around start"
            (change)="setSelectedBar(bar, i)"
          >
            {{ getBarTitle(bar) }}
          </mat-radio-button>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="10px">
          <div *ngFor="let bar of bars" fxLayout="row" fxLayoutAlign="space-around end">
            <button mat-button class="dashboard-bar__bars-list-actions" (click)="removeBar(bar)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </mat-radio-group>
    </div>
  </div>
</div>
